import React from "react";
import "./App.sass";
import EditorPanel from "./editor";

function App() {
  return (
    <div className="App">
      <EditorPanel />
    </div>
  );
}

export default App;
